import FreelancerUserPaymentMethodEnum from '../../../../Enums/FreelancerUserPaymentMethodEnum';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../../Helpers/ValidityHelper';
import EditFreelancerUserHelper from '../EditFreelancerUserHelper';

export default class PaymentInformationForSingapore {
  static returnDescriptionTab() {
    return {
      label: 'Singapore Payment Information',
      hide: (item) => EditFreelancerUserHelper.isBillingDetailHidden(item, 8),
      fields: [
        {
          fieldName: 'PaymentCurrencyId',
          label: 'Payment Currency',
          className: 'col-6',
          type: InputTypesEnum.CurrencySelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'PaymentMethod',
          label: 'Payment Method',
          className: 'col-6',
          type: InputTypesEnum.Select,
          selectvalues: EditFreelancerUserHelper.getPaymentMethodSelectOptions,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'PIWesternUnionAddress',
          label: 'Account Holder Name',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
          hide: (item) =>
            EditFreelancerUserHelper.isBillingDetailFieldHidden(item, FreelancerUserPaymentMethodEnum.BankTransfer),
        },
        {
          fieldName: 'PIBranchNameOrId',
          label: 'Bank Branch Name',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
          hide: (item) =>
            EditFreelancerUserHelper.isBillingDetailFieldHidden(item, FreelancerUserPaymentMethodEnum.BankTransfer),
        },
        {
          fieldName: 'PIBankAccountNumber',
          label: 'Bank Account Number',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
          hide: (item) =>
            EditFreelancerUserHelper.isBillingDetailFieldHidden(item, FreelancerUserPaymentMethodEnum.BankTransfer),
        },
        {
          fieldName: 'PISwiftIFSCCode',
          label: 'Swift/IFSC Code',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
          hide: (item) =>
            EditFreelancerUserHelper.isBillingDetailFieldHidden(item, FreelancerUserPaymentMethodEnum.BankTransfer),
        },
        {
          fieldName: 'PIPayNow',
          label: 'Pay Now',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
          hide: (item) =>
            EditFreelancerUserHelper.isBillingDetailFieldHidden(item, FreelancerUserPaymentMethodEnum.PayNow),
        },
      ],
    };
  }
}
